import {useMutation} from '@apollo/client';
import {UPDATE_ORDER} from "../orderTypeDefs";

export const useMutationUpdateOrder = (options?: any): any => (
  useMutation(UPDATE_ORDER, options)
);
